module.exports = __webpack_public_path__ + "img/gorbatenko_room.ae3e23df.jpg";